
import Vue, { PropType } from 'vue'
import { getCurrentUserInfo } from '@/services/auth'
import { WorkstationDocument } from '@/api/types/workstation'
import { RLoader } from '@/components'
import { UsageDocument, UsageTableRowDocument } from '@/store/types/event'
type SortOrder = null | 'ASC' | 'DESC'

type LogsData = {
  sortBy: 'date' | 'cost'
  sortOrder: SortOrder
}

export default Vue.extend({
  name: 'Logs',
  components: {
    RLoader,
  },
  props: {
    usage: {
      type: Array as PropType<Array<UsageDocument>>,
      required: true,
    },
    user: {
      type: Object, // TODO provide proper typing as PropType<...>
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data(): LogsData {
    return {
      sortBy: 'date',
      sortOrder: 'DESC',
    }
  },
  computed: {
    dateOrder(): SortOrder {
      if (this.sortBy === 'date') {
        return this.sortOrder
      }
      return 'DESC'
    },
    costOrder(): SortOrder {
      if (this.sortBy === 'cost') {
        return this.sortOrder
      }
      return null
    },
    rows(): Array<UsageTableRowDocument> {
      if (!this.usage) return []
      return this.usage.map((u: UsageDocument) => {
        return new UsageTableRowDocument({
          action: this.getAction(u.categoryName),
          resourceType: this.getResourceType(u.resource, u.resourceId),
          user: this.getLogUser(u.userId),
          date: this.getDate(u.timestamp),
        })
      })
    },
    workstations(): Array<WorkstationDocument> {
      return this.user ? this.user.workstations : []
    },
  },
  methods: {
    getAction(categoryName: string): string {
      if (categoryName === 'USER_START') {
        return 'Computer Turned ON'
      } else if (categoryName === 'USER_STOP') {
        return 'Computer Turned OFF'
      }
      return ''
    },
    getResourceType(resource: string, resourceId: string): string {
      if (resource === 'WORKSTATION') {
        const w = this.workstation(resourceId)
        return w ? w.name : `Deleted ${resourceId.slice(0, 8)}`
      } else {
        return 'UNKNOWN_RESOURCE'
      }
    },
    getLogUser(userId: string): string {
      if (this.user && getCurrentUserInfo().userId === userId) {
        return `${this.user.finalDisplayName} (you)`
      } else if (this.user && this.user.uid === userId) {
        return this.user.finalDisplayName
      }
      return `Unknown ${userId.slice(0, 8)}`
    },
    getDate(timestamp: number): string {
      return new Date(timestamp).toISOString().slice(0, 19).replace('T', ' ')
    },
    workstation(uuid: string): WorkstationDocument {
      return this.workstations.filter((w) => w.uuid === uuid)[0]
    },

    toggleDateOrder() {
      this.sortBy = 'date'
      if (this.dateOrder === null || this.dateOrder === 'ASC') {
        this.sortOrder = 'DESC'
      } else {
        this.sortOrder = 'ASC'
      }
    },
    toggleCostOrder() {
      this.sortBy = 'cost'
      if (this.costOrder === null || this.costOrder === 'ASC') {
        this.sortOrder = 'DESC'
      } else {
        this.sortOrder = 'ASC'
      }
    },
  },
})
